/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button, Col, Form, FormGroup, Input, InputGroup, Row, Table } from 'reactstrap';
import { JhiItemCount, JhiPagination, Translate, getPaginationState, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort, faSortDown, faSortUp } from '@fortawesome/free-solid-svg-icons';
import { ASC, DESC, ITEMS_PER_PAGE, SORT } from 'app/shared/util/pagination.constants';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities, searchEntities } from './accounting-expense-ledger.reducer';

export const AccountingExpenseLedger = () => {
  const dispatch = useAppDispatch();

  const pageLocation = useLocation();
  const navigate = useNavigate();

  const [search, setSearch] = useState('');
  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getPaginationState(pageLocation, ITEMS_PER_PAGE, 'id'), pageLocation.search),
  );

  const accountingExpenseLedgerList = useAppSelector(state => state.accountingExpenseLedger.entities);
  const loading = useAppSelector(state => state.accountingExpenseLedger.loading);
  const totalItems = useAppSelector(state => state.accountingExpenseLedger.totalItems);

  const getAllEntities = () => {
    if (search) {
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    } else {
      dispatch(
        getEntities({
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
  };

  const startSearching = e => {
    if (search) {
      setPaginationState({
        ...paginationState,
        activePage: 1,
      });
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
    e.preventDefault();
  };

  const clear = () => {
    setSearch('');
    setPaginationState({
      ...paginationState,
      activePage: 1,
    });
    dispatch(getEntities({}));
  };

  const handleSearch = event => setSearch(event.target.value);

  const sortEntities = () => {
    getAllEntities();
    const endURL = `?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`;
    if (pageLocation.search !== endURL) {
      navigate(`${pageLocation.pathname}${endURL}`);
    }
  };

  useEffect(() => {
    sortEntities();
  }, [paginationState.activePage, paginationState.order, paginationState.sort, search]);

  useEffect(() => {
    const params = new URLSearchParams(pageLocation.search);
    const page = params.get('page');
    const sort = params.get(SORT);
    if (page && sort) {
      const sortSplit = sort.split(',');
      setPaginationState({
        ...paginationState,
        activePage: +page,
        sort: sortSplit[0],
        order: sortSplit[1],
      });
    }
  }, [pageLocation.search]);

  const sort = p => () => {
    setPaginationState({
      ...paginationState,
      order: paginationState.order === ASC ? DESC : ASC,
      sort: p,
    });
  };

  const handlePagination = currentPage =>
    setPaginationState({
      ...paginationState,
      activePage: currentPage,
    });

  const handleSyncList = () => {
    sortEntities();
  };

  const getSortIconByFieldName = (fieldName: string) => {
    const sortFieldName = paginationState.sort;
    const order = paginationState.order;
    if (sortFieldName !== fieldName) {
      return faSort;
    }
    return order === ASC ? faSortUp : faSortDown;
  };

  return (
    <div>
      <h2 id="accounting-expense-ledger-heading" data-cy="AccountingExpenseLedgerHeading">
        <Translate contentKey="tinyMedicRestApp.accountingExpenseLedger.home.title">Accounting Expense Ledgers</Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="tinyMedicRestApp.accountingExpenseLedger.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link
            to="/accounting-expense-ledger/new"
            className="btn btn-primary jh-create-entity"
            id="jh-create-entity"
            data-cy="entityCreateButton"
          >
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="tinyMedicRestApp.accountingExpenseLedger.home.createLabel">
              Create new Accounting Expense Ledger
            </Translate>
          </Link>
        </div>
      </h2>
      <Row>
        <Col sm="12">
          <Form onSubmit={startSearching}>
            <FormGroup>
              <InputGroup>
                <Input
                  type="text"
                  name="search"
                  defaultValue={search}
                  onChange={handleSearch}
                  placeholder={translate('tinyMedicRestApp.accountingExpenseLedger.home.search')}
                />
                <Button className="input-group-addon">
                  <FontAwesomeIcon icon="search" />
                </Button>
                <Button type="reset" className="input-group-addon" onClick={clear}>
                  <FontAwesomeIcon icon="trash" />
                </Button>
              </InputGroup>
            </FormGroup>
          </Form>
        </Col>
      </Row>
      <div className="table-responsive">
        {accountingExpenseLedgerList && accountingExpenseLedgerList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th className="hand" onClick={sort('id')}>
                  <Translate contentKey="tinyMedicRestApp.accountingExpenseLedger.id">Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('id')} />
                </th>
                <th className="hand" onClick={sort('ledgerNo')}>
                  <Translate contentKey="tinyMedicRestApp.accountingExpenseLedger.ledgerNo">Ledger No</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('ledgerNo')} />
                </th>
                <th className="hand" onClick={sort('amount')}>
                  <Translate contentKey="tinyMedicRestApp.accountingExpenseLedger.amount">Amount</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('amount')} />
                </th>
                <th className="hand" onClick={sort('remarks')}>
                  <Translate contentKey="tinyMedicRestApp.accountingExpenseLedger.remarks">Remarks</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('remarks')} />
                </th>
                <th className="hand" onClick={sort('currencyRate')}>
                  <Translate contentKey="tinyMedicRestApp.accountingExpenseLedger.currencyRate">Currency Rate</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('currencyRate')} />
                </th>
                <th className="hand" onClick={sort('settled')}>
                  <Translate contentKey="tinyMedicRestApp.accountingExpenseLedger.settled">Settled</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('settled')} />
                </th>
                <th className="hand" onClick={sort('pendingAmount')}>
                  <Translate contentKey="tinyMedicRestApp.accountingExpenseLedger.pendingAmount">Pending Amount</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('pendingAmount')} />
                </th>
                <th className="hand" onClick={sort('transactedById')}>
                  <Translate contentKey="tinyMedicRestApp.accountingExpenseLedger.transactedById">Transacted By Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('transactedById')} />
                </th>
                <th className="hand" onClick={sort('transactedByType')}>
                  <Translate contentKey="tinyMedicRestApp.accountingExpenseLedger.transactedByType">Transacted By Type</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('transactedByType')} />
                </th>
                <th className="hand" onClick={sort('closed')}>
                  <Translate contentKey="tinyMedicRestApp.accountingExpenseLedger.closed">Closed</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('closed')} />
                </th>
                <th className="hand" onClick={sort('entityId')}>
                  <Translate contentKey="tinyMedicRestApp.accountingExpenseLedger.entityId">Entity Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('entityId')} />
                </th>
                <th className="hand" onClick={sort('active')}>
                  <Translate contentKey="tinyMedicRestApp.accountingExpenseLedger.active">Active</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('active')} />
                </th>
                <th className="hand" onClick={sort('cursor')}>
                  <Translate contentKey="tinyMedicRestApp.accountingExpenseLedger.cursor">Cursor</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('cursor')} />
                </th>
                <th className="hand" onClick={sort('lastUpdated')}>
                  <Translate contentKey="tinyMedicRestApp.accountingExpenseLedger.lastUpdated">Last Updated</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('lastUpdated')} />
                </th>
                <th className="hand" onClick={sort('microSec')}>
                  <Translate contentKey="tinyMedicRestApp.accountingExpenseLedger.microSec">Micro Sec</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('microSec')} />
                </th>
                <th className="hand" onClick={sort('timestampEntry')}>
                  <Translate contentKey="tinyMedicRestApp.accountingExpenseLedger.timestampEntry">Timestamp Entry</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('timestampEntry')} />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.accountingExpenseLedger.baseCurrency">Base Currency</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.accountingExpenseLedger.category">Category</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.accountingExpenseLedger.entityType">Entity Type</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.accountingExpenseLedger.accountTransaction">Account Transaction</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {accountingExpenseLedgerList.map((accountingExpenseLedger, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button tag={Link} to={`/accounting-expense-ledger/${accountingExpenseLedger.id}`} color="link" size="sm">
                      {accountingExpenseLedger.id}
                    </Button>
                  </td>
                  <td>{accountingExpenseLedger.ledgerNo}</td>
                  <td>{accountingExpenseLedger.amount}</td>
                  <td>{accountingExpenseLedger.remarks}</td>
                  <td>{accountingExpenseLedger.currencyRate}</td>
                  <td>{accountingExpenseLedger.settled ? 'true' : 'false'}</td>
                  <td>{accountingExpenseLedger.pendingAmount}</td>
                  <td>{accountingExpenseLedger.transactedById}</td>
                  <td>
                    <Translate contentKey={`tinyMedicRestApp.AddedByType.${accountingExpenseLedger.transactedByType}`} />
                  </td>
                  <td>{accountingExpenseLedger.closed ? 'true' : 'false'}</td>
                  <td>{accountingExpenseLedger.entityId}</td>
                  <td>{accountingExpenseLedger.active ? 'true' : 'false'}</td>
                  <td>{accountingExpenseLedger.cursor}</td>
                  <td>{accountingExpenseLedger.lastUpdated}</td>
                  <td>{accountingExpenseLedger.microSec}</td>
                  <td>{accountingExpenseLedger.timestampEntry}</td>
                  <td>
                    {accountingExpenseLedger.baseCurrency ? (
                      <Link to={`/accounting-currency/${accountingExpenseLedger.baseCurrency.id}`}>
                        {accountingExpenseLedger.baseCurrency.id}
                      </Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {accountingExpenseLedger.category ? (
                      <Link to={`/clinical-dictionary/${accountingExpenseLedger.category.id}`}>{accountingExpenseLedger.category.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {accountingExpenseLedger.entityType ? (
                      <Link to={`/clinical-dictionary/${accountingExpenseLedger.entityType.id}`}>
                        {accountingExpenseLedger.entityType.id}
                      </Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {accountingExpenseLedger.accountTransaction ? (
                      <Link to={`/accounting-transaction/${accountingExpenseLedger.accountTransaction.id}`}>
                        {accountingExpenseLedger.accountTransaction.id}
                      </Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button
                        tag={Link}
                        to={`/accounting-expense-ledger/${accountingExpenseLedger.id}`}
                        color="info"
                        size="sm"
                        data-cy="entityDetailsButton"
                      >
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`/accounting-expense-ledger/${accountingExpenseLedger.id}/edit?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button
                        onClick={() =>
                          (window.location.href = `/accounting-expense-ledger/${accountingExpenseLedger.id}/delete?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`)
                        }
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="tinyMedicRestApp.accountingExpenseLedger.home.notFound">No Accounting Expense Ledgers found</Translate>
            </div>
          )
        )}
      </div>
      {totalItems ? (
        <div className={accountingExpenseLedgerList && accountingExpenseLedgerList.length > 0 ? '' : 'd-none'}>
          <div className="justify-content-center d-flex">
            <JhiItemCount page={paginationState.activePage} total={totalItems} itemsPerPage={paginationState.itemsPerPage} i18nEnabled />
          </div>
          <div className="justify-content-center d-flex">
            <JhiPagination
              activePage={paginationState.activePage}
              onSelect={handlePagination}
              maxButtons={5}
              itemsPerPage={paginationState.itemsPerPage}
              totalItems={totalItems}
            />
          </div>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

export default AccountingExpenseLedger;
